// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayerByline__container__19Pyl","full":"PlayerByline__full__h-hFJ","abbr":"PlayerByline__abbr__3Jz57"};